module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Layout/Layout-top-panel-3-66f05d3cebf429c92f442349db9463ac.svg";